export default __webpack_public_path__ + "static/media/gruszka2.9d549cd4.png";